import axios from 'axios'

export async function requestHolidays (year) {
    return axios.get('https://canada-holidays.ca/api/v1/holidays', { 
        params: { year }
    })
}
